import React, { useState } from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { useWebsiteHomePageUrl } from 'src/editor/shared/hooks/use-website-home-page-url'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { Radio } from 'src/editor/shared/ui-lib/radio'
import { Tooltip } from 'src/shared/components/tooltip'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { LocoAssetsKeysType } from 'src/shared/i18next/types/loco-assets-keys-type'
import { twMerge } from 'tailwind-merge'
import { RADIO_NAME, radioList, radioValueList } from './const'
import { RadioValueType } from './types'

interface WebsiteLogoSettingsLinkProps {
  url: string
  setUrl: (url: string) => void
}

export const WebsiteLogoSettingsLink = ({
  url,
  setUrl,
}: WebsiteLogoSettingsLinkProps) => {
  const { t } = useTypedTranslation()
  const { homePageUrl } = useWebsiteHomePageUrl()
  const handleInput = (value: string) => {
    setCustomUrl(value)
    setUrl(value)
  }
  const [customUrl, setCustomUrl] = useState(url !== homePageUrl ? url : '')
  const [radioValue, setRadioValue] = useState<RadioValueType>(
    url === homePageUrl || url === ''
      ? radioValueList.homepage
      : radioValueList.custom,
  )
  const handleChangeRadio = (value: RadioValueType) => {
    setRadioValue(value)
    if (value === radioValueList.homepage) {
      setUrl(homePageUrl)
      return false
    }
    setUrl(customUrl || '')
  }

  return (
    <>
      <GroupTitle
        className="flex justify-start"
        afterChildren={
          <Tooltip
            message={t('components.website_logo.settings.link.tooltip')}
          />
        }
      >
        {t('components.website_logo.settings.link.title')}
      </GroupTitle>
      <div className="mt-2 flex flex-col gap-4">
        {radioList.map(radio => (
          <Radio
            name={RADIO_NAME}
            isChecked={radioValue === radio.value}
            onChange={() => handleChangeRadio(radio.value)}
          >
            {t(radio.label)}
          </Radio>
        ))}
      </div>

      <div className="mt-3 flex items-baseline">
        <TextInputControl
          wrapperProps={{
            className: 'mt-0 w-full',
          }}
          className={twMerge(
            radioValue === radioValueList.homepage && 'bg-bgSecondary',
          )}
          value={customUrl}
          update={value => handleInput(value.trim())}
          disabled={radioValue === radioValueList.homepage}
        />
      </div>
    </>
  )
}
